import N2StylesModal from "../components/N2StylesModal";
import AdAnnotations from "../react/annotations/AdAnnotations";
import ResolvedAnnotationsHandler from "../components/ResolvedAnnotationsHandler";

export default class DigitalJobsAnnotations {
  constructor(params) {
    this.params = params;
  }

  index() {
    N2.handle("click", "#js-new-digital-job-comment-button", () => {
      new N2StylesModal(".js-digital-job-comment-modal");
    });

    if (this.params.view === "proof") {
      this.setupAnnotations();
    }
  }

  setupAnnotations() {
    // unload here in event user pushed back in browser
    AdAnnotations.unload();
    if ($("img.js-annotation-boundry").length) {
      const img = new Image();
      img.src = $("img.js-annotation-boundry")[0].src;
      img.onload = () => {
        this.adAnnotations = AdAnnotations.init();
        this.setupResolvedHandler();
      };
    } else {
      this.adAnnotations = AdAnnotations.init();
      this.setupResolvedHandler();
    }
  }

  setupResolvedHandler() {
    const currAnno = $.grep(this.adAnnotations.annotations,
      anno => anno.id === this.params.currentAnnotation)[0] || {};

    (() => new ResolvedAnnotationsHandler({ resolved: currAnno.resolved }))();
  }
}
